<template>
  <b-row>
    <b-col cols="12">
      <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Orçamento WhatsApp</h1>
    <hr class="linha-amarela ml-2" />
    </b-col>

    <b-col cols="12">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        @click.native="get()"
      />
    </b-col>

    <b-col cols="12" class="mt-4">
      <input
        type="text"
        v-model.trim="fields.clientName"
        class="form-control"
        placeholder="Nome do cliente"
        @keypress.enter="get()"
      />
    </b-col>

    <b-col cols="" class="mt-3">
      <b-button variant="success" @click="get()">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>
    
    <b-col cols="12" class="mt-5">
      <b-table
        striped
        outlined
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
        empty-text="Nenhum produto encontrado"
      >
        <template #cell(value)>
          <span>{{ formatMoney(totalValue) }}</span>
        </template>

        <template #cell(created_at)="data">
          <span>{{ formatDate(data.item.created_at) }}</span>
        </template>

        <template #cell(action)="data">
          <b-button
            variant="warning"
            size="sm"
            title="Detalhes do orçamento"
            class="mr-2 mb-2"
            @click="$refs.detalheOrcamento.toggleOpen({dataBudget: data.item})"
          >
            <i class="fas fa-eye"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
      
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>

    <ModalDetalheOrcamentoWhatsapp
      ref="detalheOrcamento"
    />

  </b-row>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import ModalDetalheOrcamentoWhatsapp from "./ModalDetalheOrcamentoWhatsapp.vue";
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';

export default {
  name: "OrcamentoWhatsapp",
  mixins: [makeToast],
  components: {
    ModalDetalheOrcamentoWhatsapp,
    PeriodsFilters
  },
  data: () => ({
    loading: false,
    pagination: {
      currentPage: 1,
      itemsPerPage: 1,
      total: 1,
    },
    fields: {
      clientName: '',
      budgetNumber: null,
      startDate: '',
      endDate: '',
      clientName: '',
      status: [],
    },
    table: {
      headers: [
        {
          key: 'id',
          label: "Nº Orçamento",
          sortable: false,
        },
        {
          key: 'created_at',
          label: 'Data',
          sortable: false,
        },
        {
          key: 'name_client',
          label: 'Cliente',
          sortable: false,
        },
        {
          key: 'whatsapp_client',
          label: 'Whatsapp ',
          sortable: false,
        },
        // {
        //   key: 'status',
        //   label: 'Status ',
        //   sortable: false,
        // },
        {
          key: 'action',
          label: 'Detalhes do orçamento',
          sortable: false,
        },
      ],
      records: [],
    },
  }),

  watch: {
    'pagination.currentPage': function () {
      this.get();
    },
  },

  computed: {
    ...mapState(['token', 'dadosUsuario'])
  },

  created() {
    this.get();
  },
  methods: {

    async get() {
      this.loading = true;
      let queryParams = this.dadosUsuario.id;
      queryParams += `?page=${this.pagination.currentPage || 1}`;
      queryParams += `&clientName=${this.fields.clientName || ''}`;
      queryParams += `&orderNumber=${this.fields.budgetNumber || ''}`;
      queryParams += `&startDate=${this.fields.startDate || ''}`;
      queryParams += `&endDate=${this.fields.endDate || ''}`;
      queryParams += `&status=${this.fields.status || ''}`;

      const {perPage, total, data } = await shopkeeperAppApi.get(`/app/orders/get-budget/${queryParams}`);

      this.loading = false;
      this.table.records = data.data.data;
      this.pagination.itemsPerPage = perPage || 20;
      this.pagination.total = total;
    },

    formatMoney(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
   
    formatDate(data){
      return new Date(data).toLocaleDateString('pt-BR', {
        timeZone: 'UTC',
      });
    },
  },
};
</script>
